export default "__VITE_ASSET__C9A04vu6__"